module.exports = __webpack_public_path__ + "static/7-80f10bd382f0df1cd650fec59f3c9394.woff";